"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.buildAnalyticsEntityName = void 0;
require("core-js/modules/es6.regexp.replace.js");
var _analytics = _interopRequireDefault(require("@nerdwallet/analytics"));
var buildAnalyticsEntityName = function buildAnalyticsEntityName(name) {
  return name === null || name === void 0 ? void 0 : name.toLowerCase().replace(/ |\W/g, '_').substring(0, 64);
};
exports.buildAnalyticsEntityName = buildAnalyticsEntityName;
var trackCarouselInteracted = function trackCarouselInteracted(id, impression, interactionType, entityName) {
  var payload = {
    action: 'browse',
    interaction_type: interactionType,
    impression_id: impression === null || impression === void 0 ? void 0 : impression.impressionId
  };
  if (!(impression !== null && impression !== void 0 && impression.impressionId) || entityName) {
    var name = entityName || id;
    payload.entity_name = buildAnalyticsEntityName("carousel_".concat(name));
  }
  _analytics.default.track('element_interacted', payload);
};
var _default = trackCarouselInteracted;
exports.default = _default;